/*
 * File: cell-promo-code-type.ts
 * Created: 2026-01-19 20:10:00
 * Author: Val Liu <valuis0429@gmail.com>
 */

import { Component } from "vue-property-decorator";
import { BaseTableBodyCell } from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";

@Component
export default class CellPromoCodeType extends BaseTableBodyCell {
    get isCredit() {
        return this.row?.kind === "CREDIT";
    }

    get badgeClass() {
        return this.isCredit ? "badge-credit" : "badge-discount";
    }

    get badgeLabel() {
        return this.$_(
            this.isCredit ? "w_PromotionCodeCredit" : "w_PromotionCodeDiscount",
        );
    }

    get valueText() {
        if (this.isCredit) {
            const amount = this.row?.creditAmount ?? 0;
            return `$${Number(amount).toFixed(2)}`;
        }

        if (this.row?.discountType === "PERCENT") {
            const percent = this.row?.percentOff ?? 0;
            return `${percent}%`;
        }

        const amount = this.row?.amountOff ?? 0;
        return `$${Number(amount).toFixed(2)}`;
    }
}
